import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import { formatDate } from "../../Common/Utils/dateUtils";
import {
  getAllUsersTicketsListData,
  updateUserOneTicket,
} from "../../../redux/userTickets/action";
import Spinner from "../../Layouts/Spinner";

const UserTicketsList = () => {
  const [modal, setModal] = useState(false);
  const [theUserTicketStatus, setUserTicketStatus] = useState("");
  const [selectedUserTicket, setSelectedUserTicket] = useState({});
  const [params, setParams] = useState({
    search_key: "",
    page: 1,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(true);

  const ticketsList = useSelector(
    (state) => state?.reusableSlice?.getAllUserTickets
  );

  useEffect(() => {
    dispatch(getAllUsersTicketsListData(params))
      .then((res) => {
        if (res.status) {
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((e) => setIsLoading(false));
  }, [params, dispatch]);

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    setUserTicketStatus(Number(gender));
  };

  const updateComponent = (tickt) => {
    setModal(true);
    setSelectedUserTicket(tickt);
    setUserTicketStatus(() => tickt.status);
  };

  const handleCloseModal = () => {
    setUserTicketStatus("");
    setModal(false);
  };

  const handleSubmit = async () => {
    const data = {
      status: theUserTicketStatus,
      id: selectedUserTicket.id,
    };
    dispatch(updateUserOneTicket(data, setLoading))
      .then((res) => {
        if (res.data.status) {
          handleCloseModal();
        }
      })
      .catch((e) => console.log(e.message, "status update error"));
  };

  return (
    <div>
      <div className="p-3 ">
        <div className="category-wrapper d-flex justify-content-center flex-column w-100">
          <div className="d-flex justify-content-between align-items-center sub-head">
            <h4>User Ticket List</h4>
          </div>
        </div>
      </div>

      {isloading ? (
        <FullScreenLoader />
      ) : (
        <CardBody className="table-sec px-3">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sl No</th>
                <th>Company Name</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Category</th>
                <th scope="col">Message</th>
                <th scope="col">Status</th>
                <th>Create On</th>
                <th scope="col" style={{ textAlign: "center" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {ticketsList?.user_tickets?.length > 0 ? (
                ticketsList?.user_tickets?.map((item, index) => (
                  <tr key={index}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td>{item.company_name}</td>
                    <td>{item?.user_name} </td>
                    <td>{item?.category_title} </td>
                    <td>
                    <textarea 
                    disabled
                    style={{width:"100%"}}
                      value={item?.message}
                      rows="2"
                    />  
                    </td>
                    <td style={{ color: item?.status === 1 ? "green" : "red" }}>
                      {item?.status == 1
                        ? "Resolved"
                        : item?.status == 0
                        ? "Not Resolved"
                        : ""}
                    </td>
                    <td>{formatDate(item.created_on)}</td>
                    <td>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ columnGap: "10px" }}
                      >
                        <button
                          className="border-button"
                          onClick={() => updateComponent(item)}
                        >
                          <span>Change Status</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Tickets Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </CardBody>
      )}
      <CommonPagination
        params={params}
        setParams={setParams}
        pagination_meta={ticketsList?.pagination_meta}
      />
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <ModalHeader>Update the Status of User Ticket</ModalHeader>
        <ModalBody>
          <div className="form-group col-md-6">
            <label htmlFor="status">Change Status</label>
            <select
              id="status"
              title="status"
              className="form-control"
              onChange={handleChangeStatus}
              value={theUserTicketStatus}
            >
              <option value="">Select Status</option>
              <option value="1">Resolved</option>
              <option value="0">Not Resolved</option>
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="back-btn" onClick={() => handleCloseModal()}>Cancel</button>
          <button
            className="submit-btn"
            onClick={() => handleSubmit()}
            style={{ width: "max-content" }}
          >
            {!loading ? "Update" : <Spinner />}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default UserTicketsList;
